module.exports = __webpack_public_path__ + "static/media/my-aie-video.ee90a053.jpg";